import React from "react";
import { Form, ModalBuilder, Table } from "@redriver/cinnamon";
import { getOriginalClientChangeRequest } from "features/Companies/Customers/Change Requests/actions";
import { TranslatedModal } from "features/../../../shared/components/modals";
import { Button } from "semantic-ui-react";
import ComparisonBox from "features/Companies/Customers/Change Requests/ComparisonBox";

const ViewOriginalRequest = ({ requestId, clientId }) => {
  return (
    <ModalBuilder
      withForm
      loadAction={getOriginalClientChangeRequest}
      loadParams={{ requestId: requestId, clientId: clientId }}
      loadTransform={(data) => data.comparisonChecklist}
      renderTrigger={(showModal) => (
        <Table.MenuItem
          text="View Original Request"
          primary
          onClick={showModal}
        />
      )}
      renderModal={(modalProps, formProps, state, events) => (
        <TranslatedModal.Add
          {...modalProps}
          size="large"
          header="Original Request"
          className="data-check-modal custom-actions"
        >
          <Form {...formProps}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 10,
                paddingLeft: 25,
                paddingRight: 25,
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <ComparisonBox
                  header="CRM Customer Details"
                  {...formProps.value}
                  isCrm={true}
                />
                <ComparisonBox
                  header="Opal Customer Details"
                  {...formProps.value}
                  isCrm={false}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: 14,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "14px",
                    height: "max-content",
                  }}
                >
                  <Button
                    negative
                    onClick={async () => {
                      await events.onSubmit();
                    }}
                  >
                    Close
                  </Button>
                </div>
              </div>
            </div>
          </Form>
        </TranslatedModal.Add>
      )}
    />
  );
};
export default ViewOriginalRequest;
